/**
 * Disable the choice field if a label contains a div with an attribute of "data-agend-disable-choice".
 */
const disableChoices = function () {
    const disableChoices = document.querySelectorAll('div[data-agend-disable-choice]');

    disableChoices.forEach((element) => {
        let gchoice = element.closest('.gchoice');
        gchoice.querySelectorAll('input').forEach( element => element.disabled = true );
    });
};

window.addEventListener('DOMContentLoaded', () => {
    if (typeof gform === 'undefined') {
        return;
    }
    disableChoices();
    gform.addAction('gform_input_change', disableChoices, 10);
});
